import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteProjectImage = (token: string) => (
  projectId: number,
  imageId: number
) => deleteTemplateFn(token, uri.projectImageById(projectId, imageId));
